<template>
  <div
    class="container"
    :style="{
      background:
        'url(' +
        require('../../assets/img/' + bei_ing) +
        ') no-repeat center center',
      'background-size': '100% 100%',
    }"
  >
    <dingbu></dingbu>
    <div class="home_content">
      <div class="bg_color">
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">教师详情</span>
            </div>
          </div>
          <div class="box-contentpl">
            <div class="box-lodf">
              <div class="jian-img">
                <img :src="this.referral.image" alt />
              </div>
              <div class="jian-right">
                <div class="jian-name">{{ this.referral.name }}</div>
                <div class="jian-zhuanye">{{ this.referral.title }}</div>
                <div class="jian-yeji">
                  <div class="din-dang">
                    <span class="nian">{{ this.referral.age_num }}</span>
                    <span class="shi">从业年限</span>
                  </div>
                  <div class="din-dang">
                    <span class="nian">{{ this.referral.good_num }}</span>
                    <span class="shi">好评率</span>
                  </div>
                </div>
                <div class="jian-text">{{ this.referral.desc }}</div>
              </div>
            </div>
          </div>
        </div>
        <dibu></dibu>
        <daohan></daohan>
      </div>
    </div>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu
  },
  data() {
    return {
      teacher_id: '',
      referral: '',
      bei_ing: this.Public.bei_ing,
    };
  },
  created() {
    this.teacher_id = this.$route.query.id
    this.getteacher()
  },
  methods: {
    // //点击跳转到课程详情页
    // todolist() {
    //   this.$router.push({ path: "/details" });
    // },
    //点击跳转到我的资料
    profile() {
      this.$router.push({ path: "/profile" });
    },
    //访问资师接口
    getteacher() {
      let that = this;
      var url = "index/teacher_detail";
      let param = {
        teacher_id: this.teacher_id
      };
      this.post(url, param)
        .then((res) => {
          this.referral = res.data;
          // console.log(this.referral);
        })
        .catch((err) => {
          // console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import "../../css/lecturer.css";
</style>